const jobs = [
  {
    title: "SEO Intern",
    department: "Marketing",
    posted: "7 days ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid Available)",
    duration: "3 to 6 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3269630-seo-intern",
  },
  {
    title: "Digital Marketing Intern",
    department: "Marketing",
    posted: "6 days ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid Available)",
    duration: "2 to 3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3261624-digital-marketing",
  },
  {
    title: "Business Analyst Intern",
    department: "Other",
    posted: "6 days ago",
    location: "Indore, Madhya Pradesh",
    duration: "2 to 3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3260859-business-analyst",
  },
  {
    title: "Marketing Head",
    department: "Marketing",
    posted: "2 weeks ago",
    location: "Indore, Madhya Pradesh (Hybrid/Remote)",
    stipend: "₹4L – ₹7L",
    type: "Full-Time",
    remote: false,
    link: "https://wellfound.com/jobs/3251863-marketing-head",
  },
  {
    title: "IT Project Manager",
    department: "Other",
    posted: "2 weeks ago",
    location: "Indore, Madhya Pradesh",
    stipend: "₹5L – ₹7L",
    type: "Full-Time",
    remote: false,
    link: "https://wellfound.com/jobs/3251862-it-project-manager",
  },
  {
    title: "Video Editor/Creator Intern",
    department: "Marketing",
    posted: "2 weeks ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3251861-video-editor",
  },
  {
    title: "Graphic Designer Intern",
    department: "Designer",
    posted: "2 weeks ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "2 to 3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3251859-graphic-designer",
  },
  {
    title: "Social Media Manager Intern",
    department: "Marketing",
    posted: "3 weeks ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3245874-social-media-manager",
  },
  {
    title: "Recruiter/HR Intern",
    department: "Operations",
    posted: "3 weeks ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3245852-hr-recruiter-intern",
  },
  {
    title: "Content Creator Intern",
    department: "Marketing",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "2 to 3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3238009-content-creator-intern",
  },
  {
    title: "Finance & Accounts Intern",
    department: "Operations",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "2 to 3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3238006-finance-accounts",
  },
  {
    title: "UI/UX Design Intern",
    department: "Designer",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Remote/Hybrid)",
    duration: "3 months",
    stipend: "₹3,000 – ₹5,000/month (Full-Time)",
    hours: "Full-Time: 8 hrs/day, Part-Time: 4 hrs/day",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3220778-ui-ux-design",
  },
  {
    title: "Software Engineer - Intern",
    department: "Engineering",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Remote)",
    stipend: "₹3,000 – ₹5,000/month",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3188599-software-engineer-intern",
  },
  {
    title: "Chief Technology Officer (CTO)",
    department: "Management",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Onsite or Remote)",
    stipend: "₹70,000 – ₹80,000",
    type: "Full-Time",
    remote: true,
    link: "https://wellfound.com/jobs/3188600-chief-technology-officer-cto",
  },
  {
    title: "React Native Dev - Intern",
    department: "Engineering",
    posted: "1 month ago",
    location: "Indore, Madhya Pradesh (Remote)",
    stipend: "₹3,000 – ₹5,000/month",
    type: "Internship",
    remote: true,
    link: "https://wellfound.com/jobs/3202990-react-native-dev-intern",
  },
];


export default jobs;
